import React from 'react';
import Slider from '@material-ui/core/Slider';

import { debounce } from 'debounce';
import { withStyles } from '@material-ui/core/styles';
import { getSliderValues } from '../../../../utils/slider';
import { SearchFiltersUtil } from '../../../../utils/search_filters_util';

import * as styles from './styles/styles.module.scss';

const sliderBoxShadow = '0 1px 8px rgba(0,0,0,0.32)';

const GreenSlider = withStyles({
  root: {
    color: '#428a13',
    height: 4
  },
  thumb: {
    height: 16,
    width: 16,
    backgroundColor: 'white',
    boxShadow: sliderBoxShadow,
    marginTop: -6,
    marginLeft: -8
  },
  active: {},
  track: {
    backgroundColor: '#428a13',
    height: 4,
    borderRadius: 4
  },
  rail: {
    backgroundColor: '#e6e6e6',
    height: 4,
    borderRadius: 4
  }
})(Slider);

class SliderFilter extends React.Component {
  // This filter needs to maintain its own state so slider actions can be debounced
  constructor(props) {
    super(props);
    this.state = {
      displayValue: this.props.config.displayValue,
      formattedRange: this.props.config.formattedRange
    };
    // This is required in order for debounce to work.  We need to respond synchronously to the user's
    // movement of the slider by showing it at this.state.displayValue.  However,
    // this.props.config.displayValue lags behind this value, because it is only updated (via the handler()
    // callback) every 300ms by the use of debounce().  We cannot ignore it altogether because when
    // the user hits "reset" we will get an all-new props value that we must respond to (not one that is set by the
    // handler() callback).  Hence we'll track the last props value given and make sure we update state
    // whenever this changes in props.
    this.displayValueFromProps = this.props.config.displayValue;
  }

  handleChange = (event, newValue) => {
    const convertedValues = getSliderValues(newValue, this.props.config);
    this.setState(
      {
        displayValue: newValue,
        formattedRange: convertedValues.formattedRange
      },
      this.debouncedChangeHandler(event, convertedValues)
    );
  };

  debouncedChangeHandler = debounce((event, convertedValues) => {
    this.props.handler(event, convertedValues);
  }, 300);

  componentDidUpdate(prevProps) {
    if (this.displayValueFromProps !== this.props.config.displayValue) {
      this.displayValueFromProps = this.props.config.displayValue;
      this.setState({
        displayValue: this.props.config.displayValue,
        formattedRange: this.props.config.formattedRange
      });
    }
  }

  getLabel = (key, text, style) => {
    const displayFuncKey = this.props.config.displayFunction;
    const displayText = SearchFiltersUtil.getFilterDisplayFunction(displayFuncKey)(text);
    return (
      <div key={key} className={style}>
        {displayText}
      </div>
    );
  };

  getLabels = () => {
    let result = [];
    if (this.state.formattedRange) {
      result = [this.getLabel('left', this.state.formattedRange[0], styles.left), this.getLabel('right', this.state.formattedRange[1], styles.right)];
    }
    return result;
  };

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.label}>{this.getLabels()}</div>
        <div className={styles.body}>
          <GreenSlider
            min={this.props.config.initialRange[0]}
            max={this.props.config.initialRange[1]}
            value={this.state.displayValue}
            onChange={this.handleChange}
            valueLabelDisplay="off"
            aria-labelledby="range-slider"
          />
        </div>
      </div>
    );
  }
}

export default SliderFilter;
